/**
 * WOM Configuration for Vessels Client
 *
 * Client-specific configuration including:
 * - API endpoints
 * - Theme colors and styling
 * - Enabled widgets
 * - Custom behavior
 */

const vesselsWOMConfig = {
  name: "Inhanss",

  // API Configuration
  apiBaseUrl: "https://api.thewordofmouth.in",
  companyId: "inhanssv1",

  // Reviews API - uses companyId + product handle dynamically
  // No hardcoded reviewsApiUrl so it builds: /api/reviews/inhanssv1/{product-handle}

  // Brand-wide reviews (wom-core appends ?limit=500 for more reviews)
  brandReviewsApiUrl: "https://api.thewordofmouth.in/api/brand-reviews/inhanssv1",
  
  // Instagram API URL
  instagramApiUrl: "https://api.thewordofmouth.in/api/instagram-images/inhanssv1",

  // Video API URL - using inhanssv1
  videoApiUrl: "https://api.thewordofmouth.in/api/video/videos/inhanssv1",

  // Use local JSON data instead of API (set to false to use API)
  useLocalData: false, // Using live API
  localDataUrl: "/assets/wom-product-data.json", // Path to local JSON file

  // Debug mode
  debug: true,

  // Theme Colors - Override default colors (can customize for inhanss brand)
  colors: {
    primary: "#1a1a1a",
    accent: "#3b82f6",
    background: "#ffffff",
    text: "#374151",
    textLight: "#6b7280",
    border: "#e5e7eb",
    success: "#10b981",
    starColor: "#FF8C00",
  },

  // Typography
  fontFamily:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",

  // Spacing and Layout
  spacing: {
    cardRadius: "12px",
    cardPadding: "20px",
    gap: "16px",
  },

  // Widget Configuration - Enable/Disable widgets
  components: {
    socialProof: true, // Shows "X reviews in last month"
    liveUsers: true, // Shows "X people viewing now"
    ratingBreakdown: true, // Shows star rating distribution
    reviews: true, // Shows full review cards
  },

  // Override to use company-wide data instead of product-specific
  useCompanyWideData: false, // Using product-specific API that works without auth

  // Widget Settings
  settings: {
    liveUpdates: true, // Auto-refresh live data
    showVerifiedBadge: true, // Show verified purchase badges
    reviewsPerPage: 4, // Number of reviews to show initially
  },

  // Custom Callbacks (Optional)
  onWriteReview: function () {
    // Custom logic when "Write Review" is clicked
    console.log("Opening write review modal");
    // Add your custom modal logic here
  },

  onLoadMore: function () {
    // Custom logic when "Load More" is clicked
    console.log("Loading more reviews");
    // Add your custom pagination logic here
  },
};

// Export for use
if (typeof module !== "undefined" && module.exports) {
  module.exports = vesselsWOMConfig;
} else {
  // Expose to window with both names for backward compatibility
  window.vesselsWOMConfig = vesselsWOMConfig; // Primary
  window.clientWOMConfig = vesselsWOMConfig; // Alias for backward compatibility
}
